<template>
    <div class="footer">
        <div class="footer-top">
<!--            <p class="link"><a href="">常见问题</a><a href="">免责声明</a><a href="">征集意见</a><a href="">联系我们</a></p>-->
            <p class="copyright">{{this.$store.state.siteName}} www.xiaochengdaren.com 版权所有：{{this.$store.state.companyName}} {{this.$store.state.icp}}</p>
            <p class="copyright">咨询热线：0753-2354999 19128188497</p>
        </div>
        <div class="codeBox">
            <div class="item">
                <p class="img"><img src="@/assets/images/gzh.jpg"></p>
                <p>微信公众号</p>
            </div>
            <div class="item">
                <p class="img"><img src="@/assets/images/xcxewm.jpg"></p>
                <p>{{this.$store.state.siteName}}小程序</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'PublicFooter'
}
</script>
<style></style>
